import React from 'react'
import classNames from 'classnames'
import TitleLockup, { TitleLockupProps } from '../title-lockup'
import { Button, BaseButtonProps } from '../button'
import * as styles from './ComponentTitleLockup.module.scss'

export interface ComponentTitleLockupProps extends TitleLockupProps {
  bodyText1?: string
  bodyText2?: string
  layout?: 'stacked' | 'twoColumnText' | 'twoColumnButton'
  align?: 'left' | 'center'
  maxWidth?: 'md' | 'sm' | 'full'
  buttonProps?: BaseButtonProps
  paragraphMargin?: boolean
  lastParagraphMargin?: boolean
  showHeadingDivider?: boolean
}

const ComponentTitleLockup: React.FC<ComponentTitleLockupProps> = ({
  bodyText1,
  bodyText2,
  layout = 'stacked',
  align = 'left',
  maxWidth = 'full',
  buttonProps,
  paragraphMargin = false,
  lastParagraphMargin,
  showHeadingDivider = false,
  ...titleLockupProps
}) => {
  // If lastParagraphMargin is explicitly set, use it, otherwise use the paragraphMargin value
  const firstParagraphMargin = paragraphMargin ? 'var(--space-md)' : '0'
  const secondParagraphMargin =
    lastParagraphMargin !== undefined
      ? lastParagraphMargin
        ? 'var(--space-md)'
        : '0'
      : firstParagraphMargin

  return (
    <div
      className={classNames(styles.container, {
        [styles[layout]]: layout,
        [styles[align]]: align,
        [styles[maxWidth]]: maxWidth
      })}
    >
      <TitleLockup
        {...titleLockupProps}
        showHeadingDivider={showHeadingDivider}
      />
      <div>
        {bodyText1 && (
          <p
            className={classNames({
              [styles[maxWidth]]: maxWidth
            })}
            style={{ marginBottom: firstParagraphMargin }}
          >
            {bodyText1}
          </p>
        )}
        {bodyText2 && (
          <p
            className={classNames({
              [styles[maxWidth]]: maxWidth
            })}
            style={{ marginBottom: secondParagraphMargin }}
          >
            {bodyText2}
          </p>
        )}
        {buttonProps && <Button {...buttonProps} />}
      </div>
    </div>
  )
}

export default ComponentTitleLockup
